// extracted by mini-css-extract-plugin
export var bodyRow = "_c9-d";
export var cardColumns = "_c9-e";
export var ellipsesOverflow = "_c9-2";
export var flatBottomCorners = "_c9-3";
export var flatTopCorners = "_c9-4";
export var headerActionsDropdown = "_c9-f";
export var headerBottomRow = "_c9-c";
export var headerTopRow = "_c9-b";
export var orderDetailsWrapper = "_c9-0";
export var orderInfoContainer = "_c9-1";
export var productDetails = "_c9-9";
export var productImage = "_c9-5";
export var responsiveTable = "_c9-8";
export var shipmentContainer = "_c9-a";
export var tableBottomLeft = "_c9-6";
export var tableBottomRight = "_c9-7";
export var trackingLink = "_c9-g";